import Divider from "../components/Divider";
import FooterHome from "../components/FooterHome";
import MyNav from "../components/MyNav";
import WebBox from "../components/WebBox";

export default function Portfolio ({isSmallScreen}){
    return (
        <>
        <MyNav isSmallScreen={isSmallScreen} portB={true}/>
        <div className="px-[30px] sm:px-[150px] overflow-hidden mb-[3rem]">
        <p className=" font-playfair text-[55px] my-[4rem]">Our Projects</p>
            <WebBox title={"Hamzah's Portfolio"} url={"https://hamzahalnofli.com"} description={"A portfolio page made my our front-end developer as a web-based curriculum vitae."}/>
            <Divider/>
            <WebBox title={"Quest Ministries"} url={"https://questmin.org"} description={"QuestMin is a sophisticated personal website and digital portfolio built for Stan Bohall, featuring a curated collection of philosophical essays, art gallery, and professional content. The platform serves as both a literary showcase and artistic expression space, designed to engage visitors with thought-provoking content and visual storytelling."}/>

        </div>
        <FooterHome isSmallScreen={isSmallScreen}/>
        </>
    )
}